import $ from '../skizz'
import '../utils/fast-button'

/**
 * dropdown - open/close a list with a button
 *
 * @param {Object} [options] Custom options
 * @version 2.0.0
 * @return {Object} Skizz
 */
$.fn.dropdown = function dropdown (options) {
  options = $.extend({
    onActive: null,
    directParent: true,
    api: false
  }, options)

  const activeClassName = 'is-open'

  let api

  this.each(function (index, elements) {
    let parent
    let selectedIndex = NaN
    let active = false
    let menuItems
    let currentElement = $(this)

    function init () {
      currentElement.fastButton(handle)

      if (options.directParent) {
        currentElement.on('keypress', handle)
      }

      options.directParent ? parent = currentElement : parent = getParent(currentElement)
      menuItems = $('.menu-item', parent)

      if (options.onActive) {
        active = $('.is-active', parent)

        parent.on('click', function (event) {
          if (event.target.tagName !== 'A' || event.target === active) return

          event.preventDefault()
          options.onActive(event)

          if (active) {
            active.removeClass('is-active')
            active = $(event.target)
            active.addClass('is-active')
            close()
          }
        })
      }
    }

    /**
     * A dropdown must be enclosed in a .btngroup, this function searches for it
     * @private
     * @memberOf Dropdown#
     * @param {Object} element Dom element
     * @return {Object} Dom parent element of the given parameter
     */
    function getParent (element) {
      parent = element.parent()

      while (!parent.hasClass('dropdown') && parent.parent()) {
        parent = parent.parent()
      }

      return parent
    }

    /**
     * A dropdown listens for mouse clicks and key strokes
     * @param {Object} event Event object with all information about the current event
     */
    function handle (event) {
      if (event.type === 'keypress' &&
          event.keyCode !== 13 && // enter
          event.keyCode !== 27 && // escape
          event.keyCode !== 38 && // up arrow
          event.keyCode !== 40) { return } // bottom arrow

      if (event.target.tagName !== 'A') {
        event.preventDefault()
      }

      if (event.keyCode === 13) {
        if ($(event.target).hasClass('menu-item')) {
          $(event.target).fire('click')
          close()
          off()
        } else {
          if (parent.hasClass(activeClassName)) {
            close()
            off()
          } else {
            open()
            on()
          }
        }
      } else if (event.keyCode === 38) {
        if (parent.hasClass('dropdown')) {
          event.preventDefault()
        }

        if (isNaN(selectedIndex)) {
          selectedIndex = 0
        }

        selectedIndex = (selectedIndex - 1 + menuItems.length) % menuItems.length
        menuItems[selectedIndex].focus()
      } else if (event.keyCode === 40) {
        if (parent.hasClass('dropdown')) {
          event.preventDefault()
        }

        if (isNaN(selectedIndex)) {
          selectedIndex = -1
        }

        selectedIndex = (selectedIndex + 1) % menuItems.length
        menuItems[selectedIndex].focus()
      } else if (event.type === 'click' && options.directParent) {
        if (currentElement.hasClass(activeClassName)) {
          close()
          off()
        } else {
          open()
          on()
        }
      } else {
        if (currentElement.hasClass(activeClassName)) {
          close()
          off()
        } else {
          open()
          on()
        }
      }
    }

    /**
     * Opens the dropdown menu
     */
    function open () {
      parent.addClass(activeClassName).attr('aria-expanded', 'true')
    }

    /**
     * Closes the dropdown menu
     */
    function close () {
      parent.removeClass(activeClassName).attr('aria-expanded', 'false')
    }

    /**
     * Binds listeners for mouse clicks and key strokes at the document level. This is to dismiss the dropdown if any action happens outside the dropdown.
     */
    function on () {
      $(document).on('keydown click', handle)
    }

    /**
     * Unbinds listeners for mouse clicks and key strokes at the document level.
     */
    function off () {
      $(document).off('keydown click', handle)
    }

    init()

    api = {
      on: on,
      off: off,
      init: init,
      open: open,
      close: close,
      getParent: getParent,
      handle: handle
    }
  })

  return options.api ? api : this
}
